<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('admin.couponsTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_coupon: 'add_coupon',
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addGenerateCouponButton="true"
          :openGenerateCouponModal="openGenerateCouponModal"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.coupon_id"
              >
                <td>{{ r.coupon_id }}</td>
                <td>{{ r.coupon }}</td>
                <td>{{ r.staff_name }}</td>
                <!--<router-link :to="'/regular-user?name=' + r.customer_name" tag="td" ><a tooltip="View customer">{{r.customer_name}}</a></router-link>-->
                <td>{{ r.percentage }}%</td>
                <td v-if="r.coupon_status === 'used'">
                  <span class="label bg-orange-600"> {{ r.coupon_status }} </span>
                </td>
                <td v-else-if="r.coupon_status === 'unused'">
                  <span class="label bg-green-600"> {{ r.coupon_status }} </span>
                </td>
                <td v-else-if="r.coupon_status === 'exported'">
                  <span class="label bg-blue-600"> {{ r.coupon_status }} </span>
                </td>
                <td v-else>
                  <span class="label bg-danger-600"> {{ r.coupon_status }} </span>
                </td>
                <td>{{ r.created_at }}</td>
                <td>{{ r.expire_date }}</td>
                <td
                  v-if="$_has_perm('edit_coupon')"
                  class="icon-gap-5"
                >
                  <a
                    style="color:#2E7D32"
                    :tooltip="$t('admin.editPercentageTooltip')"
                    @click="openEditCouponModal(r)"
                  >
                    <i class="fa fa-percent"></i>
                  </a>
                </td>
                <!-- <td class="rtl-pl-5 rtl-pr-0">
                  <a
                    style="color:#424242"
                    :tooltip="$t('admin.giveToCustomerTooltip')"
                    @click="openGiveToCustomerModal(r)"
                  > <i class="material-icons">person_pin</i> </a>
                </td> -->
                <td
                  v-if="$_has_perm('delete_coupon')"
                  class="icon-gap-5"
                >
                  <a
                    style="color:#C62828"
                    :tooltip="$t('common.delete')"
                    @click="deleteCoupon(r.coupon_id)"
                  >
                    <i class="material-icons">delete</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isCoupon="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ r.coupon }} , <br />
                  {{ $t('columns.staff') }}: {{ r.staff_name }} , <br />
                  {{ $t('columns.percentage') }}: {{ r.percentage }}%
                </td>
                <td>
                  <span v-if="r.coupon_status === 'used'">
                    <span class="label bg-orange-600"> {{ r.coupon_status }} </span> <br />
                  </span>
                  <span v-else-if="r.coupon_status === 'unused'">
                    <span class="label bg-green-600"> {{ r.coupon_status }} </span> <br />
                  </span>
                  <span v-else-if="r.coupon_status === 'exported'">
                    <span class="label bg-blue-600"> {{ r.coupon_status }} </span> <br />
                  </span>
                  <span v-else>
                    <span class="label bg-danger-600"> {{ r.coupon_status }} </span> <br />
                  </span>
                  {{ r.created_at }} <br />
                  {{ $t('columns.expireDate') }}: {{ r.expire_date }} <br />
                  <a
                    style="color:#2E7D32; display: inline-block;" class="rtl-pl-5"
                    :tooltip="$t('admin.editPercentageTooltip')"
                    @click="openEditCouponModal(r)"
                  >
                    <i class="fa fa-percent"></i>
                  </a>
                  <a
                    style="color:#C62828;" class="rtl-float-left"
                    :tooltip="$t('common.delete')"
                    @click="deleteCoupon(r.coupon_id)"
                  >
                    <i class="material-icons">delete</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <generate-coupon
            :generateCouponModal="generateCouponModal"
            :closeGenerateCouponModal="closeGenerateCouponModal"
            :generateData="generateData"
            :generateCoupon="generateCoupon"
            :checkAlert="checkAlert"
          >
          </generate-coupon>

          <edit-coupon
            :closeEditCouponModal="closeEditCouponModal"
            :editCouponModal="editCouponModal"
            :editCoupon="editCoupon"
            :checkAlert="checkAlert"
            :editData="editData"
          >
          </edit-coupon>

          <give-to-customer
            :closeGiveToCustomerModal="closeGiveToCustomerModal"
            :giveToCustomerModal="giveToCustomerModal"
            :giveToCustomer="giveToCustomer"
            :checkAlert="checkAlert"
            :giveData="giveData"
            :customers="customers"
          >
          </give-to-customer>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import generateCoupon from './generateCoupon.vue'
import editCoupon from './editCoupon.vue'
import giveToCustomer from './giveToCustomer.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'generate-coupon': generateCoupon,
    'edit-coupon': editCoupon,
    'give-to-customer': giveToCustomer,
    'mobile-datatable': mobileDatatable
  },
  created() {
    this.getResults()
  },
  mounted() {
    this.perPageFix()
    this.getCustomer()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'coupon_id' },
      {
        label: this.$t('columns.coupon'),
        text: this.$t('columns.coupon'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'coupon'
      },
      {
        label: this.$t('columns.staffName'),
        text: this.$t('columns.staffName'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'staff_name'
      },
      // {label: "Customer Name", text: 'OrderID', value: '3', sortable: true, searchable: true, name: "customer_name"},
      { label: '%', text: '%', value: '4', sortable: true, searchable: true, name: 'percentage' },
      {
        label: this.$t('columns.status'),
        text: this.$t('columns.status'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'coupon_status'
      },
      {
        label: this.$t('columns.createDate'),
        text: this.$t('columns.createDate'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'created_at'
      },
      {
        label: this.$t('columns.expireDate'),
        text: this.$t('columns.expireDate'),
        value: '7',
        sortable: true,
        searchable: true,
        name: 'expire_date'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      url: 'api/coupons',
      editUrl: 'api/coupons',
      deleteUrl: 'api/coupons',
      getCustomerUrl: 'api/get-customer',
      updateStatusUrl: 'api/coupon-status',
      giveToCustomerUrl: 'api/give-to-customer',
      callExportUrl: 'api/call-export',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      generateCouponModal: false,
      giveToCustomerModal: false,
      editCouponModal: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      customersResult: [],
      customers: [],
      detailResults: [],
      columns: columns,
      sortKey: 'coupon_id',
      sortOrders: sortOrders,
      the_coupon_id: '',
      exportedCouponId: [],
      generateData: {
        percentage: '',
        coupon_number: '',
        expire_date: ''
      },
      editData: {
        percentage: ''
      },
      giveData: {
        customer_id_fk: ''
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'coupon_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    openGenerateCouponModal() {
      this.generateCouponModal = true
    },

    closeGenerateCouponModal() {
      this.generateCouponModal = false
      this.clearGenerateData()
    },

    clearGenerateData() {
      this.generateCouponModal = false
      this.checkAlert = false
      this.generateData.coupon_number = ''
      this.generateData.percentage = ''
    },

    generateCoupon(expireDate) {
      let token = localStorage.getItem('access_token')
      axios
        .post(this.url, this.generateData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.getResults()
          this.checkAlert = true
          let a = this
          setTimeout(function () {
            a.clearGenerateData()
            expireDate.time = ''
          }, 2000)
        })
        .catch(error => {
          if (error.response) {
            swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          }
        })
    },

    deleteCoupon(id) {
      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('admin.onceDeletedCouponWarning'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.deleteUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
            .then(response => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    openEditCouponModal(r) {
      this.the_coupon_id = r.coupon_id
      this.editData.percentage = r.percentage
      this.editCouponModal = true
    },

    closeEditCouponModal() {
      this.editCouponModal = false
      this.checkAlert = false
    },

    editCoupon() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editUrl + '/' + this.the_coupon_id, this.editData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.getResults()
          this.checkAlert = true
        })
        .catch(error => {
          if (error.response) {
            swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          }
        })
    },

    openGiveToCustomerModal(r) {
      this.the_coupon_id = r.coupon_id
      this.giveData.customer_id_fk = r.customer_id
      this.giveToCustomerModal = true
    },

    closeGiveToCustomerModal() {
      this.checkAlert = false
      this.giveToCustomerModal = false
    },

    giveToCustomer() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.giveToCustomerUrl + '/' + this.the_coupon_id, this.giveData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.getResults()
          this.checkAlert = true
        })
        .catch(error => {
          if (error.response) {
            swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          }
        })
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.getCustomerUrl, {
          params: this.customerParam,
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.customersResult = response.data.data.data

          this.customersResult.forEach(c => {
            this.customers.push({ text: c.full_name, value: c.user_id })
          })
        })
    },

    sendToExport() {
      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/coupon-export')

      let a = this
      setTimeout(function () {
        a.updateCouponStatus()
      }, 2000)
    },

    updateCouponStatus() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.updateStatusUrl, this.exportedCouponId, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.getResults()
        })
        .catch(error => {
          if (error.response) {
            swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          }
        })
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'coupon_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'coupon_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'coupon_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'coupon_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/coupons/coupon.vue